import React, { Component } from 'react'
import { Table, Spin } from 'antd'
import moment from 'moment'
import numeral from 'numeral'

class ListItems extends Component {
  getColumns = () => {
    return [
      {
        title: 'ID',
        dataIndex: 'id',
        sorter: (a, b) => a.id - b.id
      },
      {
        title: 'Number',
        dataIndex: 'number',
        sorter: (a, b) => a.number - b.number
      },
      {
        title: 'Job ID',
        dataIndex: 'job_id'
      },
      {
        title: 'Job Name',
        dataIndex: 'job_name',
        sorter: (a, b) => a.job_name.localeCompare(b.job_name)
      },
      {
        title: 'Company',
        dataIndex: 'organization_name'
      },
      {
        title: 'Description',
        dataIndex: 'description'
      },
      {
        title: 'Status',
        dataIndex: 'status'
      },
      {
        title: 'Amount',
        dataIndex: 'amount'
      },
      {
        title: 'Created Date',
        dataIndex: 'created_date',
        sorter: (a, b) => {
          if (moment(a.created_date).isBefore(moment(b.created_date))) {
            return -1
          }
          return 1
        }
      }
    ]
  }

  getData = () => {
    const { fullReport } = this.props

    let data = fullReport.map((item, index) => {
      item.created_date = moment(new Date(item.created_date)).format('YYYY-MM-DD')
      item.amount = numeral(item.grand_total).format('$0,0.00')
      item.key = item.id
      return item
    })

    return data
  }

  getTotalAmount = () => {
    const { fullReport } = this.props
    var sum = 0
    fullReport.forEach(item => {
      sum += item.grand_total
    })
    return sum
  }

  tableComponents = (key = 'tableKey') => ({ className, style, children }) => (
    <table className={className} style={style} key={key}>
      {children}
      <tfoot>
        <tr>
          <td className="padding8">Totals</td>
          <td />
          <td />
          <td />
          <td />
          <td />
          <td />
          <td className="padding8">{numeral(this.getTotalAmount()).format('$0,0.00')}</td>
          <td />
        </tr>
      </tfoot>
    </table>
  )

  render() {
    const { loadingFullReport, fullReport } = this.props
    return (
      <div>
        {loadingFullReport && <Spin />}
        {!loadingFullReport &&
          fullReport && (
            <div>
              <div style={{ marginTop: 20 }} className="row">
                <div className="col-12">
                  <h5>Change Orders</h5>
                </div>
              </div>
              <Table
                pagination={false}
                columns={this.getColumns()}
                dataSource={this.getData()}
                size="small"
                components={{ table: this.tableComponents() }}
                style={{ backgroundColor: 'white' }}
              />
            </div>
          )}
      </div>
    )
  }
}

export default ListItems



// WEBPACK FOOTER //
// ./src/components/reports/jobs/change-orders/ListItem.js